import { Navigate, useLocation } from "react-router-dom";

export default function RequireAdmin({ children }) {
  const loc = useLocation();

  const userId = localStorage.getItem("userId");
  const roleFromStorage = (localStorage.getItem("role") || "").toLowerCase();

  const isAdmin = !!userId && (roleFromStorage === "admin" || roleFromStorage === "superadmin");

  if (!isAdmin) {
    const to = userId ? "/dashboard" : "/login";
    return <Navigate to={to} replace state={{ from: loc }} />;
  }

  return children;
}
